export default "__VITE_ASSET__BDhA4u6l__"